import { ACTION_TOAST_DURATION_MS, CLOSEABLE_TOAST_DURATION_MS } from "@constants/ui";
import { getLanguageDirection } from "@hooks/useLanguageDirection";
import { getToastOffset } from "@utils/ui";
import { cn } from "kz-ui-sdk";
import React from "react";
import reactHotToast, { ToastOptions } from "react-hot-toast";
import { MdCancel, MdInfo, MdInfoOutline, MdWarning } from "react-icons/md";
import ActionToast from "./ActionToast";

const toast = {
  ...reactHotToast,
  info: (message: string, options?: ToastOptions) =>
    reactHotToast(message, {
      icon: <MdInfoOutline className="h-5 w-5 text-informative-600" />,
      ...options,
    }),
  warning: (message: string, options?: ToastOptions) =>
    reactHotToast(message, {
      icon: <MdWarning className="h-5 w-5 text-warning-500" />,
      ...options,
    }),
  infoWithClose: (message: string, options?: ToastOptions) =>
    reactHotToast(
      (t) => (
        <div className={cn("flex items-start gap-2")}>
          {t.icon ? t.icon : <MdInfo className="h-5 w-5 text-informative-600" />}
          <span className="leading-5 text-content-base">{message}</span>
          <button
            className="absolute end-0 top-0 -translate-y-1/2 text-accentBrand-300 translate-start-1/2"
            onClick={() => reactHotToast.dismiss(t.id)}
            aria-label={`Close toast: ${message}`}
            data-element-id="button-info-toast-close"
          >
            <MdCancel className="h-5 w-5 text-accentBrand-300" />
          </button>
        </div>
      ),
      {
        duration: CLOSEABLE_TOAST_DURATION_MS,
        ...(options || {}),
        style: {
          marginTop: getToastOffset({}),
          direction: getLanguageDirection(),
        },
      },
    ),
  warningWithClose: (message: string | React.ReactNode, options?: ToastOptions) =>
    reactHotToast(
      (t) => (
        <div className={cn("flex items-start gap-2")}>
          {t.icon ? t.icon : <MdWarning className="h-5 w-5 text-warning-500" />}
          <span className="leading-5 text-content-base">{message}</span>
          <button
            className="absolute end-0 top-0 -translate-y-1/2 text-accentBrand-300 translate-start-1/2"
            onClick={() => reactHotToast.dismiss(t.id)}
            aria-label={`Close toast: ${message}`}
            data-element-id="button-warning-toast-close"
          >
            <MdCancel className="h-5 w-5 text-accentBrand-300" />
          </button>
        </div>
      ),
      {
        duration: CLOSEABLE_TOAST_DURATION_MS,
        ...(options || {}),
        style: {
          marginTop: getToastOffset({}),
        },
      },
    ),
  warningWithAction: (
    baseMessage: string,
    actionButtonText: string,
    onActionClick: () => void,
    options?: ToastOptions & { icon?: React.ReactNode; reasonLabel?: string; reasonValue?: string },
  ) =>
    reactHotToast(
      (t) => (
        <ActionToast
          t={t}
          baseMessage={baseMessage}
          reasonLabel={options?.reasonLabel}
          reasonValue={options?.reasonValue}
          actionButtonText={actionButtonText}
          onActionClick={onActionClick}
          icon={options?.icon}
        />
      ),
      {
        duration: ACTION_TOAST_DURATION_MS,
        ...(options || {}),
        style: {
          marginTop: getToastOffset({}),
        },
      },
    ),
};

export default toast;
